// @mui
import { styled } from '@mui/material/styles';
import { ListItemIcon, ListItemButton } from '@mui/material';
import { Colors } from '../../landingPage/style/theme';

// ----------------------------------------------------------------------

export const StyledNavItem = styled((props) => <ListItemButton disableGutters {...props} />)(({ theme }) => ({
  ...theme.typography.body2,
  height: 50,
  position: 'relative',
  textTransform: 'capitalize',
  fontSize: 18,
  color: Colors.white,
  borderRadius: theme.shape.borderRadius,
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
  width: 45,
  height: 25,
  color: Colors.white,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
